(function (window, $) {
    'use strict';

    if (!$ || window.BMHShellInitialized) {
        return;
    }

    window.BMHShellInitialized = true;

    var reducedMotion = Boolean(
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    function initNavigation() {
        var $nav = $('.bmh-nav').first();
        var $toggle = $('[data-bmh-nav-toggle]').first();
        var $menu = $('[data-bmh-nav-menu]').first();
        var $links = $('[data-bmh-section-link]');
        var $home = $('[data-bmh-home-link]').first();
        var ticking = false;

        function closeMenu() {
            $menu.removeClass('is-open');
            $toggle.attr('aria-expanded', 'false');
        }

        function offset() {
            return ($nav.length ? $nav.outerHeight() : 0) + 12;
        }

        function updateActive() {
            var position = $(window).scrollTop() + offset() + 70;
            var $active = $home;

            $links.each(function () {
                var selector = $(this).attr('href');

                if (!selector || selector.charAt(0) !== '#') {
                    return;
                }

                var $section = $(selector).first();

                if ($section.length && $section.offset().top <= position) {
                    $active = $(this);
                }
            });

            $home.add($links)
                .removeClass('is-active')
                .removeAttr('aria-current');

            if ($active.length) {
                $active.addClass('is-active').attr(
                    'aria-current',
                    $active[0] === $home[0] ? 'page' : 'location'
                );
            }

            ticking = false;
        }

        $toggle.on('click.bmhNav', function () {
            var open = $menu.toggleClass('is-open').hasClass('is-open');
            $toggle.attr('aria-expanded', String(open));
        });

        $(document).on('keydown.bmhNav', function (event) {
            if (event.key === 'Escape') {
                closeMenu();
            }
        });

        $links.on('click.bmhNav', function (event) {
            var selector = $(this).attr('href');

            if (!selector || selector.charAt(0) !== '#') {
                closeMenu();
                return;
            }

            var $target = $(selector).first();

            if (!$target.length) {
                closeMenu();
                return;
            }

            event.preventDefault();

            var top = Math.max(0, $target.offset().top - offset());

            if (reducedMotion) {
                window.scrollTo(0, top);
            } else {
                $('html, body').stop(true).animate({ scrollTop: top }, 450);
            }

            closeMenu();
        });

        function scheduleUpdate() {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(updateActive);
            }
        }

        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate, { passive: true });

        updateActive();
    }

    function initUrgentTicker() {
        var $viewport = $('[data-bmh-urgent-viewport]').first();
        var $track = $('[data-bmh-urgent-track]').first();
        var $group = $('[data-bmh-urgent-group]').first();

        if (!$viewport.length || !$track.length || !$group.length) {
            return;
        }

        var $play = $('[data-bmh-urgent-play]').first();
        var $icon = $play.find('[data-bmh-urgent-play-icon], i').first();
        var state = {
            offset: 0,
            width: 0,
            paused: false,
            hover: false,
            dragging: false,
            moved: false,
            pointerStart: 0,
            offsetStart: 0,
            lastFrame: window.performance.now()
        };

        // Hold still on load so the newest notice can be read, matching the home gallery
        // (2s delayed init + 2s autoplay delay).
        var startDelay = 4000;
        var startAt = window.performance.now() + startDelay;

        function apply() {
            $track.css('transform', 'translate3d(' + state.offset + 'px,0,0)');
        }

        function normalize() {
            if (!state.width) {
                return;
            }

            while (state.offset > 0) {
                state.offset -= state.width;
            }

            while (state.offset < -state.width) {
                state.offset += state.width;
            }
        }

        function measure() {
            state.width = $group.outerWidth() || 0;
            // state.offset = state.width ? -state.width : 0; // _delbk: showed oldest notices first
            // Items are rendered oldest -> newest; start with the newest at the right edge
            // so it is read first as the ticker moves right (RTL).
            state.offset = state.width ? ($viewport.innerWidth() || 0) - state.width : 0;
            normalize();
            apply();
        }

        function frame(now) {
            var delta = Math.min(42, now - state.lastFrame);
            state.lastFrame = now;

            if (
                state.width &&
                now >= startAt &&
                !state.paused &&
                !state.hover &&
                !state.dragging &&
                !reducedMotion
            ) {
                state.offset += 0.04 * delta;
                normalize();
                apply();
            }

            window.requestAnimationFrame(frame);
        }

        function jump(amount) {
            state.offset += amount;
            normalize();
            apply();
        }

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(measure);
        });
        window.requestAnimationFrame(frame);

        $(window).on('resize.bmhUrgent', measure);

        // The Urdu web font changes item widths once it loads; re-anchor the newest notice.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(measure);
        }

        $viewport
            .on('mouseenter.bmhUrgent focusin.bmhUrgent', function () {
                state.hover = true;
            })
            .on('mouseleave.bmhUrgent focusout.bmhUrgent', function () {
                state.hover = false;
            })
            .on('pointerdown.bmhUrgent', function (event) {
                state.dragging = true;
                state.moved = false;
                state.pointerStart = event.originalEvent.clientX;
                state.offsetStart = state.offset;
            })
            .on('pointermove.bmhUrgent', function (event) {
                if (!state.dragging) {
                    return;
                }

                var distance = event.originalEvent.clientX - state.pointerStart;

                if (Math.abs(distance) < 7 && !state.moved) {
                    return;
                }

                state.moved = true;
                event.preventDefault();
                state.offset = state.offsetStart + distance;
                normalize();
                apply();
            })
            .on('pointerup.bmhUrgent pointercancel.bmhUrgent', function () {
                state.dragging = false;
            })
            .on('click.bmhUrgent', '.bmh-urgent__item', function (event) {
                if (state.moved) {
                    event.preventDefault();
                    state.moved = false;
                }
            });

        $('[data-bmh-urgent-prev]').first().on('click.bmhUrgent', function () {
            jump(280);
        });

        $('[data-bmh-urgent-next]').first().on('click.bmhUrgent', function () {
            jump(-280);
        });

        $play.on('click.bmhUrgent', function () {
            state.paused = !state.paused;
            $icon.toggleClass('fa-pause', !state.paused)
                .toggleClass('fa-play', state.paused);
            $play.attr({
                'aria-label': state.paused
                    ? 'Start urgent notices'
                    : 'Pause urgent notices',
                'aria-pressed': String(state.paused)
            });
        });
    }

    // Print buttons ([data-bmh-print]) and the print date shown in the print footer.
    function initPrint() {
        function updatePrintDate() {
            var now = new Date();
            var pad = function (value) {
                return String(value).padStart(2, '0');
            };
            var text = pad(now.getDate()) + '-' + pad(now.getMonth() + 1) + '-' + now.getFullYear()
                + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());

            $('[data-print-datetime]').text(text);
        }

        window.addEventListener('beforeprint', updatePrintDate);

        $(document).on('click.bmhPrint', '[data-bmh-print]', function (event) {
            event.preventDefault();
            updatePrintDate();
            window.print();
        });
    }

    $(function () {
        initNavigation();
        initUrgentTicker();
        initPrint();
        $('.bmh-page').addClass('is-ready');
    });
})(window, window.jQuery);
